const form = document.querySelector('.desek-donation-form');

if(form != null){
    const buttons = document.querySelectorAll(".desek-donation-form button[aria-controls*='step-']");
    const steps = document.querySelectorAll(".desek-donation-form [id*='step-']");

    removeEmptyParagraphs();

    for(button of buttons){
        button.addEventListener('click', changeStep);
    }


    function changeStep() {
        let aria_controls = this.getAttribute('aria-controls');
        // Task 1
        removeActives();



        // Task 2: Find target step and display it
        for(let step of steps){
            if(step.getAttribute('id') === aria_controls){
                step.classList.add('active');
            }
        }

        // Task 3: Scroll to form for better ux.
        /*
        let top_position = form.offsetTop;
        window.scrollTo({
            top: top_position,
            left: 0,
            behavior: 'smooth'
        });

         */
    }

    function testLog(){
        console.log('testLog');
    }


    /**
     * Remove all actives classes from step-* <div> elements
     */
    function removeActives(){
        for(step of steps){
            step.classList.remove('active');
        }
    }

    function removeEmptyParagraphs(){
        const p = form.querySelectorAll('p');

        for(let ps of p){
            if(ps.innerText == ""){
                ps.remove();
            }

        }
    }

}